import manifest from "./manifest.js";

const aliases = {
  [manifest.SABLIER_FLOW]: "FL3",
};

export default aliases;
